import Storage from '@/shared/utils/storage.js'
import getUserData from './getUserData.js'

async function saveUserInLocalData(context, userData) {
  try {
    userData ||= await getUserData(context)
    if (userData) Storage.save('userData', userData)
    else Storage.delete('userData')
  } catch (error) {
    console.log('🚀 ~ AuthService ~ initLocalUser ~ error:', error)
  }
}

export default saveUserInLocalData
